import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps, useHistory } from "react-router-dom";
import classnames from "classnames";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
} from "reactstrap";

import { BreadCrumb } from "../../components/Common";
import { AppVersionPage } from "./AppVersionPage";
import { HomeWorkAlertPage } from "./HomeWorkAlertPage";
import { ExamNoticePage } from "./ExamNoticePage";
import { TermsOfServicePage } from "./TermsServicePage";
import { PrivacyPolicyPage } from "./PrivacyPolicyPage";
import { SupplicationsPage } from "./SupplicationsPage";
import { AskTeacherAlertPage } from "./AskTeacherAlertPage";

type TProps = RouteComponentProps & {};

export const ControlAppTabsPage: React.FC<TProps> = () => {
  //#region hooks
  const { t } = useTranslation();
  const history = useHistory();
  //#endregion

  //#region internal state
  const [activeTab, setActiveTab] = useState(history.location.hash || "2");
  //#endregion

  //#region effects
  useEffect(() => {
    const hash = history.location.hash;
    if (hash) {
      switch (hash) {
        case "#application-version":
          setActiveTab("2");
          break;
        case "#privacy-policy":
          setActiveTab("3");
          break;
        case "#terms-of-service":
          setActiveTab("4");
          break;
        case "#study-supplication":
          setActiveTab("6");
          break;
        case "#exam-notice":
          setActiveTab("7");
          break;
        case "#homework-alert":
          setActiveTab("9");
          break;
        case "#ask-teacher-alert":
          setActiveTab("10");
          break;
        default:
          setActiveTab("2");
          break;
      }
    }
  }, []);

  //#endregion

  //#region handlers
  const pillsToggle = (changingTab: any) => {
    if (activeTab !== changingTab) {
      setActiveTab(changingTab);
    }
  };
  //#endregion

  useEffect(() => {
    console.log("activeTab ", activeTab);
  }, [activeTab]);

  document.title = `${t("documentTitle", { pageName: "controlApp" })}`;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("controlApp")} pageTitle={t("")} />
          <Row>
            <Col xxl={12}>
              <Card>
                <CardBody>
                  <Nav pills className="nav-success">
                    <NavItem>
                      <NavLink
                        href="#application-version"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "2" },
                          "d-flex",
                        )}
                        onClick={() => {
                          pillsToggle("2");
                        }}
                      >
                        <i className="ri-smartphone-line fs-14"></i>&nbsp;
                        {t("applicationVersion")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="#privacy-policy"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "3" },
                          "d-flex",
                        )}
                        onClick={() => {
                          pillsToggle("3");
                        }}
                      >
                        <i className="ri-file-shield-line fs-14"></i>
                        &nbsp;
                        {t("privacyPolicy")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="#terms-of-service"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "4" },
                          "d-flex",
                        )}
                        onClick={() => {
                          pillsToggle("4");
                        }}
                      >
                        <i className="ri-file-list-line fs-14"></i>&nbsp;
                        {t("termsOfService")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="#study-supplication"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "6" },
                          "d-flex",
                        )}
                        onClick={() => {
                          pillsToggle("6");
                        }}
                      >
                        <i className="ri-book-open-line fs-14"></i>&nbsp;
                        {t("studySupplications")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="#exam-notice"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "7" },
                          "d-flex",
                        )}
                        onClick={() => {
                          pillsToggle("7");
                        }}
                      >
                        <i className="ri-article-line fs-14"></i>&nbsp;
                        {t("examNotice")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="#homework-alert"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "9" },
                          "d-flex",
                        )}
                        onClick={() => {
                          pillsToggle("9");
                        }}
                      >
                        <i className="ri-file-list-line"></i>&nbsp;
                        {t("homeworkAlert")}
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        href="#ask-teacher-alert"
                        style={{ cursor: "pointer" }}
                        className={classnames(
                          { active: activeTab === "10" },
                          "d-flex",
                        )}
                        onClick={() => {
                          pillsToggle("10");
                        }}
                      >
                        <i className="ri-file-list-line"></i>&nbsp;
                        {t("askTeacherAlert")}
                      </NavLink>
                    </NavItem>
                  </Nav>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="2" id="application-version">
              {activeTab === "2" && <AppVersionPage />}
            </TabPane>
            <TabPane tabId="3" id="privacy-policy">
              {activeTab === "3" && <PrivacyPolicyPage />}
            </TabPane>
            <TabPane tabId="4" id="terms-of-service">
              {activeTab === "4" && <TermsOfServicePage />}
            </TabPane>
            <TabPane tabId="6" id="study-supplications">
              {activeTab === "6" && <SupplicationsPage />}
            </TabPane>
            <TabPane tabId="7" id="exam-notice">
              {activeTab === "7" && <ExamNoticePage />}
            </TabPane>
            <TabPane tabId="9" id="homework-alert">
              {activeTab === "9" && <HomeWorkAlertPage />}
            </TabPane>
            <TabPane tabId="10" id="ask-teacher-alert">
              {activeTab === "10" && <AskTeacherAlertPage />}
            </TabPane>
          </TabContent>
        </Container>
      </div>
    </React.Fragment>
  );
};
